import React from 'react';
import { Redirect } from 'react-router-dom';
import { reservationsTodaysPath } from '../../Paths';

export default () => <Redirect to={reservationsTodaysPath} />;
